import { useEffect, useState } from "react";
import { Dropdown } from "semantic-ui-react";
import { getDropdownSemanticOption, useFetchData } from "../../../helpers/GlobalHelper";
import "../../../styles/lms/lms-global.scss";

const LmsActionDropdown = (
  {
    optionsSuffix,
    label = "",
    handleChange,
    values = {} as any,
    value = undefined as any,
    disabled = false
  }) => {
  const [{ data, isLoading }] = useFetchData(optionsSuffix ? optionsSuffix : "");
  const [options, setOptions] = useState(undefined as any[] | undefined);

  useEffect(() => {
    if (data && !options) {
      setOptions(data?.map(o => getDropdownSemanticOption(o.name, o.id)));
    }
  }, [data]);

  return <div>
    <span className="lms-flex-centered-row-container">
      {label && <span className="dropdown-table-actions-label-container">{label}</span>}
      <Dropdown
        options={options}
        name={optionsSuffix}
        search
        clearable
        selection
        loading={isLoading}
        value={values[optionsSuffix] || value}
        onChange={handleChange}
        className="lms-table-action-dropdown-button"
        disabled={disabled}
      /></span>
  </div>;
};

export default LmsActionDropdown;